const state = {
  isAuthenticated: !!localStorage.getItem("token"),
  user: JSON.parse(localStorage.getItem("user")) || null,
  token: localStorage.getItem("token") || null,
};

const mutations = {
  setUser(state, user) {
    state.user = user;
    user
      ? localStorage.setItem("user", JSON.stringify(user))
      : localStorage.removeItem("user");
  },
  setToken(state, token) {
    state.token = token;
    token
      ? localStorage.setItem("token", token)
      : localStorage.removeItem("token");
    state.isAuthenticated = !!token;
  },
  logout(state) {
    state.user = null;
    state.token = null;
    state.isAuthenticated = false;
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  },
};

const actions = {
  login({ commit }, { user, token }) {
    commit("setUser", user);
    commit("setToken", token);
  },
  logout({ commit }) {
    commit("logout");
  },
  updateUser({ commit, state }, updatedData) {
    const updatedUser = {
      ...state.user,
      username: updatedData.username || state.user.username,
      email: updatedData.email || state.user.email,
      role: updatedData.role || state.user.role,
    };

    commit("setUser", updatedUser);
  },
};

const getters = {
  isAuthenticated: (state) => state.isAuthenticated,
  getUser: (state) => state.user,
  userRole: (state) => state.user?.role,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
